module.exports = __webpack_public_path__ + "static/media/l4.6a773dd1.jpg";